import { endPoints } from 'api/';
import { UPDATE_ATTRIBUTE } from 'actions/types';

/**
 * @description Updates attribute array of object.
 * @param {{
 * attributes: [{}]
 * company_id: string
 * }} payload
 * @returns Attribute object
 */
function update(payload) {
  const { attributes } = payload;
  const itemId = attributes[0]?.entity_id;
  /**
   * @param {Function} dispatch
   */
  return function (dispatch) {
    const action = {
      type: UPDATE_ATTRIBUTE,
      /**
       * @param {Function} apiClient
       */
      request: async function (apiClient) {
        const attribute = await apiClient(endPoints.UPDATE_ATTRIBUTE, payload);
        const result = {
          ...attribute,
          data: {
            ...attribute.data,
            response: {
              itemId,
              attributes: attribute.data.response,
            },
          },
        };
        return result;
      },
    };
    dispatch(action);
  };
}

export default update;
